import { PayRequestPayload } from "checkout-query-client/api/types";
import {
  getAcceptedMandates,
  getDeviceFingerprintSessionId,
} from "checkout-query-client/utils/helpers";

import {
  EncryptedWallet,
  EncryptedWalletPaymentBundle,
  PayRequest,
  PaymentMethod,
  PaymentMethod_Type,
  PazeEncryptedPaymentBundle,
} from "frontend-client";

import { buildPostalPayloadFromPaze } from "./build-base-payload";

export const buildPazePayload = async (
  payload: PayRequestPayload
): Promise<PayRequest> => {
  const { formFields, checkoutSessionData, orderDigest } = payload;
  const request = new PayRequest();
  const wallet = new EncryptedWallet();
  const paymentMethod = new PaymentMethod();
  const encryptedPaymentBundle = new EncryptedWalletPaymentBundle();
  const pazeEncryptBundle = new PazeEncryptedPaymentBundle();

  pazeEncryptBundle.encryptedPayload = formFields?.pazeCompleteToken ?? "";
  pazeEncryptBundle.last4OfCardPan = formFields?.pazeLastFour ?? "";

  encryptedPaymentBundle.encryptedPaymentBundle.case =
    "pazeEncryptedPaymentBundle";
  encryptedPaymentBundle.encryptedPaymentBundle.value = pazeEncryptBundle;

  wallet.encryptedWalletPaymentBundle = encryptedPaymentBundle;
  wallet.billingAddress = buildPostalPayloadFromPaze(formFields);

  paymentMethod.wallet = wallet;
  paymentMethod.type = PaymentMethod_Type.WALLET;

  request.paymentMethod = paymentMethod;
  request.acceptedMandates = getAcceptedMandates(payload.formFields);
  request.billingAddressFromIntentBilling = Boolean(
    checkoutSessionData?.billingAddress
  );
  request.orderDigest = orderDigest ?? "";
  request.deviceFingerprintSessionId = getDeviceFingerprintSessionId();

  return Promise.resolve(request);
};
